<div class="modalContainer">
    <div class="modal-header">
        <div class="modal-title">Negotiate Loan Settlement
            <div class="modal-sub-title">Please enter the negotiated terms</div>
        </div>
    </div>

    <div *ngIf="!matDialogData">
        <mat-spinner [diameter]="35" class="mat-spinner center-block"></mat-spinner>
    </div>

    <ng-container *ngIf="matDialogData">
        <div class="modal-body">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">

                <div class="row mb-5 d-flex justify-content-center">
                    <div class="col-xs-12 col-md-5 bg-grey rectangle">
                        <div class="row d-flex justify-content-around">
                            <div class="col-sm-8">
                                <mat-label class="text-color-darker-grey">Principal Outstanding: </mat-label>
                            </div>
                            <div class="col-sm-4 text-end">
                                <span class="font-bold text-success">₹{{ matDialogData.principalOutstandingBeforeSettlement | number: '1.2-2' }}</span>
                            </div>
                        </div>
                    </div>
    
                    <div class="col-xs-12 col-md-5 bg-grey rectangle">
                        <div class="row d-flex justify-content-around">
                            <div class="col-sm-8">
                                <mat-label class="text-color-darker-grey">Settlement Amount Offered: </mat-label>
                            </div>
                            <div class="col-sm-4 text-end">
                                <span class="font-bold text-color-finzy-blue">₹{{ matDialogData.settlementAmountOffered | number: '1.2-2'  }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="w-100 row d-flex justify-content-center align-items-center ">
                    <div class="col-xs-12 col-md-6 d-flex flex-column">
                        <mat-label class="text-secondary">Settlement Amount Demanded:</mat-label>
                        <mat-form-field class="input-field" appearance="outline">
                            <input matInput formControlName="settlementAmountDemanded" placeholder="Enter your amount">
                        </mat-form-field>
                    </div>
                </div>

                <div class="button-div w-100 d-flex justify-content-center align-items-center flex-wrap">
                    <button mat-stroked-button color="primary" type="button" class="primary no-text-transform mat-stroked-button mr-4" (click)="decline()">BACK</button>
                    <button type="submit" mat-flat-button color="primary" class="primary mat-flat-button" [disabled]="!form.valid">SUBMIT</button>
                </div>
            </form>
        </div>
    </ng-container>
</div>